The free-text label of the status.

Provide a name or description, e.g. `Final interview`.
